import { Formik } from 'formik';
import { initialValuesEnrollment, validationSchemaEnrollment } from './InvitationsValidationForm';
import Form from "./enrollmentForms";
import { useAxios } from '../../../../context/AxiosHookContext';
import { useNotification } from '../../../../context/NotificationContext';

const FormCreateEnrollment = ({ valuesToEdit, onClose, getValues }) => {

    const axios = useAxios();
    const { showSnackbar } = useNotification();

    const handleSubmit = async (enrollment) => {

        try {

            if (enrollment._id) {

                await axios.put(`/enrollment/update/${enrollment._id}`, enrollment)

            } else {

                await axios.post(`/enrollment/create`, enrollment)
            }
            showSnackbar({ severity: "success", title: "Invitación", message: "Se ha actualizado el concurso de forma exitosa." });

            getValues();

        } catch (error) {
            const message = error?.response?.data?.message || "Ha ocurrido un error al crear el concurso."
            showSnackbar({ severity: "error", title: "Invitación", message })
        }

    }

    const getInitialValues = () => {
        return (valuesToEdit && Object.keys(valuesToEdit).length) > 0 ? valuesToEdit : initialValuesEnrollment
    }
    
    return (
        <Formik
            validationSchema={validationSchemaEnrollment}
            initialValues={getInitialValues()}
            onSubmit={handleSubmit}
        >
            <>
                <Form onClose={onClose} />
            </>
        </Formik>
    )
}

export { FormCreateEnrollment }